import React from 'react';
import ImageViewComfy from '@material-ui/icons/ViewComfy';
import ActionDashBoard from '@material-ui/icons/Dashboard';
import EditorFormatListBulleted from '@material-ui/icons/FormatListBulleted';
import CommunicationEmail from '@material-ui/icons/Email';
import SocialPerson from '@material-ui/icons/Person';
import ContentAddCircleOutline from '@material-ui/icons/AddCircleOutline';
import AvEqualizer from '@material-ui/icons/Equalizer';
import ActionLogoutBtn from '@material-ui/icons/ExitToApp';
import MapIcon from '@material-ui/icons/Map';
import Assignment from '@material-ui/icons/AssignmentInd';
import TableChart from '@material-ui/icons/TableChart';
import SvgIcon from '@material-ui/core/SvgIcon';
import Moves from './Icons/moves.svg';
import ManageConusMoves from './Icons/manageConusMoves.svg';
import ManageMoves from './Icons/manageMoves.svg';
import ConusMoves from './Icons/conusMoves.svg';

const iconStyle = {
  customStyle: {
    fill: 'white',
  },
};

export const styles = (theme) => ({
  listItem: {
    padding: '7px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  text: {
    color: 'white',
    padding: '0px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  icon: {
    marginRight: '8px',
    minWidth: '20px',
  },
});

export const icons = {
  view_comfy: <ImageViewComfy style={iconStyle.customStyle} />,
  dashboard: <ActionDashBoard style={iconStyle.customStyle} />,
  list: <EditorFormatListBulleted style={iconStyle.customStyle} />,
  email: <CommunicationEmail style={iconStyle.customStyle} />,
  person: <SocialPerson style={iconStyle.customStyle} />,
  add_circle_outline: <ContentAddCircleOutline style={iconStyle.customStyle} />,
  equalizer: <AvEqualizer style={iconStyle.customStyle} />,
  logout: <ActionLogoutBtn style={iconStyle.customStyle} />,
  map: <MapIcon style={iconStyle.customStyle} />,
  assignment: <Assignment style={iconStyle.customStyle} />,
  table_chart: <TableChart style={iconStyle.customStyle} />,
  moves: <SvgIcon component={Moves} style={iconStyle.customStyle} viewBox="0 0 43.2 43.2" />,
  manage_moves: <SvgIcon component={ManageMoves} style={iconStyle.customStyle} viewBox="0 0 43.2 43.2" />,
  manage_conus_moves: <SvgIcon component={ManageConusMoves} style={iconStyle.customStyle} viewBox="0 0 43.2 43.2" />,
  conus_moves: <SvgIcon component={ConusMoves} style={iconStyle.customStyle} viewBox="0 0 43.2 43.2" />,
};
